module.exports = __webpack_public_path__ + "static/media/18-4.7731a5b4.mp3";